<template>
    <b-modal v-model="modalShow"
             size="lg"
             title="予約詳細"
             :ok-only="true"
             ok-title="閉じる"
             ok-variant="yokumiru-gray"
             @hidden="close">

        <div v-if="consultation">
            <div class="card">
                <div class="card-header">
                    <div class="font-weight-bold">{{ $locale.patient }}情報</div>
                </div>

                <div class="card-body">
                    <user-profile
                        :user="consultation.user"
                        :doctorId="consultation.doctor_id"
                        userType="doctor">
                    </user-profile>
                </div>
            </div>

            <div class="card mt-3">
                <div class="card-header">
                    <div class="font-weight-bold">予約情報</div>
                </div>

                <div class="card-body">
                    <dl>
                        <dt>予約番号</dt>
                        <dd>
                            <span>{{ consultation.id }}</span>
                            <span v-if="Number( consultation.flg_reserved_by_doctor ) === 1"
                                  class="small">
                                （医師による予約）
                            </span>
                        </dd>
                    </dl>
                    <dl>
                        <dt>予約日時</dt>
                        <dd class="u-palt">
                            <div>
                                <span>{{ helper.dateForHuman( consultation.start_time, timezone,{ exceptYear: true } ) }}</span>
                                <span class="small font-weight-bold"
                                      :class="helper.dayForHumanCSS( consultation.start_time ,timezone )">
                                    {{ helper.dayForHuman( consultation.start_time,timezone , { bracket: true } ) }}
                                </span>
                                <span>{{ helper.timeForHuman( consultation ,timezone ) }}</span>
                            </div>
                        </dd>
                    </dl>
                    <dl>
                        <dt>{{ $locale.consultation_host }}科</dt>
                        <dd>{{ consultation.medical_course.name }}</dd>
                    </dl>
                    <dl>
                        <dt>受付メモ</dt>
                        <dd>{{ consultation.memo }}</dd>
                    </dl>
                </div>
            </div>

            <div class="mt-3">
                <div class="mb-3">
                    <doctor-interview-answers
                          :consultation-id="consultation.id"
                          :flg-reserved-by-doctor="consultation.flg_reserved_by_doctor">
                    </doctor-interview-answers>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper';

    export default {
        props: {
            timezone: {
                type: String,
                default: 'Asia/Tokyo',
            },
        },
        data: function() {
            return {
                helper: YokumiruHelper,
                consultation: null,
                modalShow: false,
            };
        },

        created: function() {
            bus.$on( 'open-modal-doctor-consultation-detail', this.open );
        },

        beforeDestroy: function () {
            bus.$off( 'open-modal-doctor-consultation-detail' );
        },

        methods: {
            open: function ( consultation ) {
                this.modalShow = true;
                this.consultation = consultation;
            },

            close: function () {
                this.modalShow = false;
                this.consultation = null;
            },
        },
    }
</script>

<style scoped lang="scss">
    img {
        max-width: 240px;
    }

    .medical-courses-list .btn {
        font-size: .7rem;
        background: #98a6ad;
        border: none;
        cursor: default;

        &:focus {
            box-shadow: none;
        }
    }
</style>
